import React from "react";

import { Bookmark } from "lucide-react";

import { useAppDispatch, useAppSelector } from "../../Store/Hooks";
import { toggleSponsorTipBookmark } from "../../Store/Reducers/SponsorTipsSlice";

type BookmarkButtonProps = {
  slug: string;
  className?: string;
};

const BookmarkButton: React.FC<BookmarkButtonProps> = ({
  slug,
  className = "",
}) => {
  const dispatch = useAppDispatch();
  const { slugs, loaded: bookmarksReady } = useAppSelector(
    state => state.sponsorTips.bookmarks
  );

  if (!slug || !bookmarksReady) return null;

  const saved = slugs.includes(slug);

  return (
    <button
      type="button"
      aria-label={saved ? "Remove from saved" : "Save guidance"}
      aria-pressed={saved}
      title={saved ? "Remove from saved" : "Save to your library"}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(toggleSponsorTipBookmark({ slug, wasSaved: saved }));
      }}
      className={`inline-flex items-center justify-center rounded-md p-1.5 transition-colors ${
        saved
          ? "bg-[#f5ebff] text-[#974ae4]"
          : "text-gray-400 hover:bg-gray-100 hover:text-[#974ae4]"
      } ${className}`}
    >
      <Bookmark className={`h-4 w-4 ${saved ? "fill-current" : ""}`} />
    </button>
  );
};

export default BookmarkButton;
